import { render, staticRenderFns } from "./ReportStatistics_register.vue?vue&type=template&id=3a01b4f4&scoped=true"
import script from "./ReportStatistics_register.vue?vue&type=script&lang=js"
export * from "./ReportStatistics_register.vue?vue&type=script&lang=js"
import style0 from "./ReportStatistics_register.vue?vue&type=style&index=0&id=3a01b4f4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a01b4f4",
  null
  
)

export default component.exports